import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import OrgSettingsSection from "../components/OrgSettingsSection";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import AccountSection from "../components/AccountSection";
import TeamManagementSection from "../components/TeamManagementSection";
import AuditLogSection from "../components/AuditLogSection";

export default function SettingsPage() {
  useDocumentTitle("Settings");
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const isRootUser = user && user.is_root_user;
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = isRootUser ? "orgSettings" : "account";
  const tabFromUrl = searchParams.get("tab");

  const [value, setValue] = React.useState(defaultTab);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchParams({ tab: newValue });
  };
  React.useEffect(() => {
    if (user && !tabFromUrl) {
      setValue(defaultTab);
      setSearchParams({ tab: defaultTab });
    }
    setValue(tabFromUrl);
    if (tabFromUrl === "subscription" && !isRootUser) {
      navigate("/settings?tab=account", { replace: true });
    }
    if (tabFromUrl === "teamManagement" && !isRootUser) {
      navigate("/settings?tab=account", { replace: true });
    }
    if (tabFromUrl === "orgSettings" && !isRootUser) {
      navigate("/settings?tab=account", { replace: true });
    }
    if (tabFromUrl === "auditLog" && !isRootUser) {
      navigate("/settings?tab=account", { replace: true });
    }
  }, [tabFromUrl, isRootUser, defaultTab, navigate]);

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        aria-label="settings tabs"
      >
        {isRootUser && (
          <Tab value="orgSettings" label={"Organization Settings"} />
        )}
        {isRootUser && <Tab value="teamManagement" label={"Team Management"} />}
        {isRootUser && <Tab value="auditLog" label={"Audit Logs"} />}
        <Tab value="account" label={"Accounts"} />
      </Tabs>

      <Box sx={{ p: 2 }}>
        {value === "orgSettings" && <OrgSettingsSection />}
        {value === "account" && <AccountSection />}
        {value === "teamManagement" && <TeamManagementSection />}
        {value === "auditLog" && isRootUser && <AuditLogSection />}
      </Box>
    </Box>
  );
}
